import { render } from "./TrainListHeaderGroup.vue?vue&type=template&id=4f16cb4f"
import script from "./TrainListHeaderGroup.vue?vue&type=script&lang=ts"
export * from "./TrainListHeaderGroup.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./TrainListHeaderGroup.vue?vue&type=style&index=0&id=4f16cb4f&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
